<div class="row p-0">
    <div class="card p-0">
  
      <div class="bg-light p-2">
        <div class="row align-items-center">
            <div class="col-12 col-md-3">
                <label for="teams" class="pb-2">{{'Select Team'|translate}}</label>
                <select class="form-select taskspanel" id="teams" #selectedTeam (change)="getTeamDetails(selectedTeam.selectedIndex)">
                  <option value="0">Select</option>
                  <option *ngFor="let c of teamList">{{ c.teamName }}</option>
                </select>
            </div>
            <div class="col-12 col-md-3">
                <!-- Input field for description -->
                <label for="description" class="pb-2">{{'Description'|translate}}</label>
                <input
                    type="text"
                    class="form-control inputfields"
                    id="description"
                    aria-describedby="name"
                />
            </div>
            <div class="col-12 col-md-3">
                <!-- <select
                class="form-select taskspanel" 
                id="manager"  
              >
                <option value="0">Select</option>
                <option
                  value="{{ c.id}}"
                  *ngFor="let c of mangerList  "
                >
                  {{ c.name }}
                </option>  
              </select> -->
              <label for="manager" class="pb-2">{{'Manager'|translate}}</label>
                <input
                    type="text"
                    class="form-control inputfields"
                    id="manager"
                    aria-describedby="name"
                    autocomplete="off"
                    [(ngModel)]="manager"
                    readonly
                />
            </div>
            <!-- Save button -->
            <div class="col-md-3 text-end">
                <div class="d-flex justify-content-end mt-4">
                    <div class="add_button" (click)="createTeamEvent()">
                        <span style="font-size:21px;" (click)="createTeamEvent()">
                            +
                        </span>
                    </div>
                    <div class="add_button ms-2">
                        <span>
                            <i class="fa-solid fa-pen"></i>
                        </span>
                    </div>
                    <div class="delete_button ms-2">
                        <span>
                            <i class="fa-solid fa-calendar-minus"></i>
                        </span>
                    </div>
                    <button type="button" class="btn btn-primary ms-2" (click)="save()"><i class="fa-solid fa-file"></i> Save</button>
                </div>
            </div>
        </div>
    </div>
    <div class="card-body common_scroller fixed_height p-0">
        <div class="container-fluid">
            <div class="row mt-2">
                <div class="col-5" style="width: 47.666667%;">
                    <div class="card">
                        <div class="bg-light d-flex align-items-center p-2">
                            <div class="d-flex align-items-center justify-content-between w-100">
                                <span style="font-size: 19px; margin-top: 7px; font-weight: 600;">Unassigned Members</span>
                          <form [formGroup]="form">
                            <div class="input-group searchvehicles bg-white">
                              
                              <input
                              (keyup)="page =1"
                              formControlName="searchValue"
                              name="searchValue"
                                type="text"
                                class="form-control reportsbox"
                                placeholder="{{'Search'|translate}}"
                                autocomplete="off"
                                style="width: 25vh;"
                              />
                            
                              <div class="input-group-append">
                                <button
                                  class="btn"
                                  type="button"
                                  style="padding: 1vh 1.4vh 1.1vh 1.4vh"
                                >
                                  <img
                           
                                    src="/assets/icons/searchicon.png"
                                    alt="search"
                                    style="width: 2.3vh"
                                  />
                                </button>
                              </div>
                            </div>
                          </form>
                            </div>         
                          </div>
                        <div class="card-body " style="height:50vh">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th class="table_head_text"><input type="checkbox"></th>
                                        <th class="table_head_text">Employee ID</th>
                                        <th class="table_head_text">Name</th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="unassignedEmpList.length">
                                    <tr *ngFor="let emp of unassignedEmpList  | searchPipe : form.value.searchValue |  paginate : {
                                         itemsPerPage: pageOption,
                                          currentPage: page,
                                         totalItems: (unassignedEmpList  | searchPipe : form.value.searchValue).length
                                          };let i=index">
                                        <td><input type="checkbox" [(ngModel)]="selectedEmpIndices[i]"></td>
                                        <td>{{ emp.empId }}</td>
                                        <td>{{ emp.name }}</td>
                                      </tr>
                                
                                </tbody>
                                <tbody *ngIf="!unassignedEmpList.length">
                                    <tr>
                                        <td colspan="7">
                                            <div class="d-flex justify-content-center align-items-center" style="height: 48vh">
                                                <img src="/assets/images/datanotfound.png" alt="NO DATA AVAILABLE IN TABLE" />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        
                        </div>
                        <div *ngIf="unassignedEmpList.length" class="flex_row_center_spacebetweenForPagination"
                        style="padding:1.5vh 2vh;border-top: 1px solid #E3E7EC;">
                        <div>{{'Showing'|translate}} {{page}} {{'to'|translate}} {{(unassignedEmpList | searchPipe : form.value.searchValue).length/pageOption |
                            number: '1.0-0'}} {{'of'|translate}}
                            {{(unassignedEmpList | searchPipe : form.value.searchValue).length}} {{'entries'|translate}}</div>
                        <pagination-controls (pageChange)="page = $event"></pagination-controls>
                    </div>
                    </div>
                </div>
                <div class="col-1 flexContainer" style="width:2.666667%">
                    <div class="navigation_buttons">
                        <div class="nav_button" (click)="moveToAssigned()">></div>
                        <div class="nav_button"(click)="moveToAssigned()">&gt;&gt;</div>
                        <div class="nav_button"(click)="moveToUnassigned()">&lt;</div>
                        <div class="nav_button" (click)="moveToUnassigned()">&lt;&lt;</div>
                    </div>
                </div>
                <div class="col-5" style="width: 47.666667%;">
                    <div class="card">
                        <div class="bg-light d-flex align-items-center p-2">
                            <div class="d-flex align-items-center justify-content-between w-100">
                                <span style="font-size: 19px; margin-top: 7px; font-weight: 600;">Assigned Members</span>
                          <form [formGroup]="form">
                            <div class="input-group searchvehicles bg-white">
                              
                              <input
                              (keyup)="page =1"
                              formControlName="assignSearchValue"
                              name="assignSearchValue"
                                type="text"
                                class="form-control reportsbox"
                                placeholder="{{'Search'|translate}}"
                                autocomplete="off"
                                style="width: 25vh;"
                              />
                            
                              <div class="input-group-append">
                                <button
                                  class="btn"
                                  type="button"
                                  style="padding: 1vh 1.4vh 1.1vh 1.4vh"
                                >
                                  <img
                           
                                    src="/assets/icons/searchicon.png"
                                    alt="search"
                                    style="width: 2.3vh"
                                  />
                                </button>
                              </div>
                            </div>
                          </form>
                            </div>         
                          </div>
                        <div class="card-body " style="height:50vh">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th class="table_head_text"><input type="checkbox"></th>
                                        <th class="table_head_text">Employee ID</th>
                                        <th class="table_head_text">Name</th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="assignedEmpList.length">
                                    <tr *ngFor="let emp of assignedEmpList  | searchPipe : form.value.assignSearchValue |  paginate : {
                                         itemsPerPage: pageOption,
                                          currentPage: page,
                                         totalItems: (assignedEmpList  | searchPipe : form.value.assignSearchValue).length
                                          };let i=index">
                                        <td><input type="checkbox"  [(ngModel)]="selectedAssignedEmpIndices[i]"></td>
                                        <td>{{ emp.empId }}</td>
                                        <td>{{ emp.name }}</td>
                                      </tr>
                                
                                </tbody>
                                <tbody *ngIf="!assignedEmpList.length">
                                    <tr>
                                        <td colspan="7">
                                            <div class="d-flex justify-content-center align-items-center" style="height: 48vh">
                                                <img src="/assets/images/datanotfound.png" alt="NO DATA AVAILABLE IN TABLE" />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        
                        </div>
                        <div *ngIf="assignedEmpList.length" class="flex_row_center_spacebetweenForPagination"
                        style="padding:1.5vh 2vh;border-top: 1px solid #E3E7EC;">
                        <div>{{'Showing'|translate}} {{page}} {{'to'|translate}} {{(assignedEmpList | searchPipe : form.value.assignSearchValue).length/pageOption |
                            number: '1.0-0'}} {{'of'|translate}}
                            {{(assignedEmpList | searchPipe : form.value.assignSearchValue).length}} {{'entries'|translate}}</div>
                        <pagination-controls (pageChange)="page = $event"></pagination-controls>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
  </div>
  <app-creat-team
  *ngIf="isCreatTeamOpenPopUp"
></app-creat-team>   